import { useUser } from "@features/user/use-user";
import { fetchServer } from "@features/utils";
import { useState } from "react";
import { useQueryClient } from "react-query";
import { useParams } from "react-router-dom";

export const useCreateImage = () => {
  const client = useQueryClient();
  const { refresh } = useUser();
  const [loading, setLoading] = useState(false);
  const { site } = useParams();
  return {
    loading,
    create: async (arg: {
      size?: string | { width: number; height: number };
      mode: string;
      prompt: string;
      model_id?: string;
      style_id?: string;
      pack_id?: string;
      project_id?: string;
      count: number;
      from_image?: string;
      similarity?: number;
      fast?: boolean;
    }) => {
      setLoading(true);
      try {
        await fetchServer("/api/images", { site, ...arg });
        console.log("Creating image and invalidating queries");
        client.invalidateQueries(["images", "list"]);
        refresh(); // Refresh credits
      } finally {
        setLoading(false);
      }
    },
  };
};
